class ComponentSearch extends HTMLElement {
  constructor() {
    super();
    this.searchField = this.querySelector('input[name="q"]');
    this.results = this.querySelector('.search-results');
    this.form = this.querySelector('form');
    this.searchDelay = 300;
    this.searchType = 'product';
    this.controller = null;
    this.requestTimeout = 0;
    this.predictiveSearch = this.dataset.predictiveSearch=='true';
    this.showPrice = this.dataset.showPrice=='true';

    if (this.dataset.autocomplete == "true") {
      if (this.predictiveSearch) {
        this.searchType = 'product,collection';
      }
      this.documentClickHandler = this.documentClick.bind(this);
      this.searchField.addEventListener('input', this.doSearch.bind(this));
      this.searchField.addEventListener('focus', ()=> {
        if (!this.resultsVisible) {
          this.searchField.dispatchEvent(new CustomEvent('input'));
        }
      });
    }

    this.form.addEventListener('submit', (e)=>{
      e.preventDefault();
      const formData = new FormData(this.form);
      const searchParams = new URLSearchParams(formData);
      const query = searchParams.get('q');
      if(query && query!="") {
        searchParams.set('q', '*'+query+'*');
        location = this.form.action + '?' + searchParams.toString();
      }
    });
  }

  //term param allows to trigger custom search from js code.
  doSearch(term) {
    var standardSearchTerm = typeof(term)=="string" ? term : '*'+this.searchField.value.trim()+'*';
    if (this.predictiveSearch)
      term = typeof(term)=="string" ? term : this.searchField.value.trim();
    else 
      term = standardSearchTerm;
    if (this.controller) {
      this.controller.abort();
      this.controller = null;
    }
    clearTimeout(this.requestTimeout);
    if (standardSearchTerm.length>=5) {
      this.showSearchingResults();
      this.requestTimeout = setTimeout(()=>{
        this.controller = new AbortController();
        var searchSectionId = this.predictiveSearch ? 'search_predictive_json' : 'search_standard_json';
        var searchUrl = this.predictiveSearch ? '/search/suggest?resources[type]='+ this.searchType +'&q='+ encodeURIComponent(term) + '&resources[limit]=6&section_id='+ searchSectionId : '/search?section_id='+ searchSectionId +'&type='+ this.searchType +'&q='+ encodeURIComponent(term);
        $s.get({
          signal: this.controller.signal,
          url: searchUrl,
          success: (data)=>{
            if (!this.resultsVisible) {
              return;
            }
            var parser = new DOMParser();
            var doc = parser.parseFromString(data, "text/html");
            var response = JSON.parse(doc.querySelector('div').innerHTML);
            this.clearResults(false);
            var categories = 0;
            if (response.results_count > 0 || (response.collections && response.collections.length>0)) {
              var title = document.createElement('div'); 
              title.innerHTML = "Search results"; //title for screen reader
              title.classList.add('visually-hidden');
              this.results.appendChild(title);
              var items = document.createElement('div');
              items.classList.add('search-results-items');
              this.results.appendChild(items);
              if (response.results_count > 0) {
                categories++;
                var group = document.createElement('div');
                group.classList.add('search-results-product', 'search-results-group');
                var title = document.createElement('div');
                items.appendChild(title);
                title.outerHTML = '<div class="result-group-title-wrapper"><div class="result-group-title">Products</div></div>'
                items.appendChild(group);
                response.results.forEach((item)=>{
                  group.appendChild(this.buildItem(item));
                });
              }
              if (response.collections && response.collections.length > 0) {
                categories++;
                var group = document.createElement('div');
                group.classList.add('search-results-collections', 'search-results-group');
                var title = document.createElement('div');
                items.appendChild(title);
                title.outerHTML = '<div class="result-group-title-wrapper"><div class="result-group-title">Collections</div></div>'
                items.appendChild(group);
                response.collections.forEach((item)=>{
                  group.appendChild(this.buildItem(item));
                });
              }
              if (categories>1) {
                items.classList.add('multi-category');
              }
              if (response.results_count > response.results.length) {
                var linkUrl = '/search?type='+ this.searchType +'&q='+ encodeURIComponent(standardSearchTerm);
                this.results.appendChild(this.buildSeeAllLink(linkUrl, response.results_count));
              }
            } else {
              this.noResults();
            }
          }
        });
      }, this.searchDelay);
    } else {
      this.clearResults();
    }
  }

  buildItem(itemJson) {
    var img = document.createElement('img');
    var info = document.createElement('div');
    var title = document.createElement('div');
    var a = document.createElement('a');
    a.classList.add("result-item", "flex", "direction-row", "justify-content-start", "align-items-start");
    a.href = itemJson.url;
    img.src = itemJson.thumbnail ? itemJson.thumbnail : '';
    img.alt = '';
    title.classList.add('title');
    title.innerHTML = itemJson.title;
    a.appendChild(img);
    a.appendChild(info);
    info.appendChild(title);
    info.classList.add('info');
    if (this.showPrice && itemJson.price != undefined) {
      var price = document.createElement('div');
      price.classList.add('price', 'money');
      price.innerHTML = $s.formatMoney(itemJson.price).replace('.00', '');
      info.appendChild(price);
    }
    return a;
  }

  buildSeeAllLink(url, resultsQuantity) {
    var a = document.createElement('a');
    a.classList.add('see-all');
    a.href = url;
    if (this.predictiveSearch) {
      a.innerHTML = 'See all results';
    } else {
      a.innerHTML = 'See all ' + resultsQuantity + ' results';
    }
    return a;
  }

  showSearchingResults() {
    this.resultsVisible = true;
    if (!this.results.style.minHeight) {
      document.addEventListener('click', this.documentClickHandler);

      var height = this.results.offsetHeight;
      this.results.style.minHeight = Math.max(height, 80)  + 'px';
      this.results.innerHTML = '<div style="height: 100%;" class="loader-wrap flex justify-content-center align-items-center"><div class="loader" style="border-top-color: #ccc;"></div></div>';
    }
  }

  clearResults(removeEvents=true) {
    if(removeEvents) {
      document.removeEventListener('click', this.documentClickHandler);
      this.resultsVisible = false;
    }
    this.results.innerHTML = '';
    this.results.style.minHeight = '';
  }

  noResults() {
    this.results.innerHTML = '<div class="no-results">No results</div>';
  }

  documentClick(e) {
    if(!this.contains(e.target)) {
      this.clearResults();
    }
  }
}
customElements.define('search-form', ComponentSearch);